module.exports = function() {
    var restful = {
        initialize: function() {
            this.registerEvents();
        },

        registerEvents: function() {
            $(document).on({
                click: this.handleMethod
            }, 'a[data-method]');
        },

        handleMethod: function(e) {
            e.preventDefault();

            var link = $(this);
            var httpMethod = link.data('method').toUpperCase();

            if (link.attr('disabled')) return false;

            // If the data-method attribute is not PUT or DELETE,
            // then we don't know what to do. Just ignore.
            if ($.inArray(httpMethod, ['POST', 'PUT', 'PATCH', 'DELETE']) === -1) {
                return;
            }


            // if no data-confirm='foo', submit right away
            if (! link.data('confirm')) {
                return restful.submitRequest(link);
            }

            swal({
                title: link.data('confirm'),
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Zrušit'
            }).then(result => {
                if (result.dismiss) {
                    return false;
                }
                restful.submitRequest(link);
            });

            return false;
        },

        submitRequest: function(link) {
            var form,
                form = restful.createForm(link);
            form.submit();
        },

        createForm: function(link) {
            var form = $('<form>', {
                method: 'POST',
                action: link.attr('href')
            });

            var token = $('<input>', {
                type: 'hidden',
                name: '_token',
                value: App.csrfToken
            });

            var hiddenInput = $('<input>', {
                name: '_method',
                type: 'hidden',
                value: link.data('method')
            });

            return form.append(token, hiddenInput).appendTo('body');
        }
    };

    restful.initialize();
};



// WEBPACK FOOTER //
// ./resources/assets/js/vn/data-method.js